<template>
    <module-templates
        v-if="moduleInfoIsSet"
        :service="service()"
        @selected="selectionChanged"
    >
        <loading v-if="fetchingJobs" class="pt-16"></loading>
        <template v-else>
            <div v-if="template" class="mt-32">
                <div class="text-body font-semibold flex items-center justify-between mb-16">
                    <h2>
                        {{ $t('competence-templates.link_jobs') }}
                    </h2>
                </div>

                <autocomplete-selector
                    v-if="!fetchingJobs"
                    :value="selectedJobs"
                    @input="updateJobAttributes"
                    @selected="toggleLinkedJob"
                    :current-items="allJobs"
                    :autoFocus="false"
                    :place-holder="$t('jobs.search')"
                />
            </div>
        </template>
    </module-templates>
</template>

<script>
import * as competenceTemplateService from "../../services/CompetenceTemplateService";
import * as jobService from "../../services/JobService";

import {mapActions, mapState} from "pinia";
import {useMainStore} from "../../state/store";
import {useNotificationsStore} from "../../state/modules/notifications";

import AutocompleteSelector from "../../components/ui/AutocompleteSelector.vue";
import ModuleTemplates from "./ModuleTemplates.vue";
import Loading from "../../components/ui/Loading.vue";
import SimpleButton from "../../components/ui/SimpleButton.vue";
import SvgIcon from "../../components/ui/SvgIcon.vue";
import {ADD_NOTIFICATION} from "../../state/mutation-types";

export default {
    name: "CompetenceTemplates",
    components: {
        ModuleTemplates,
        AutocompleteSelector,
        SimpleButton,
        Loading,
        SvgIcon,
    },
    data: function () {
        return {
            moduleInfoIsSet: false,
            template: null,
            saving: false,
            allJobs: null,
            fetchingJobs: false,
            selectedJobs: null,
        }
    },
    computed: {
        ...mapState(useMainStore, ['locale']),
    },
    methods: {
        ...mapActions(useMainStore, ['setTemplateModuleInfo']),
        ...mapActions(useNotificationsStore, [ADD_NOTIFICATION]),
        service() {
            return competenceTemplateService;
        },
        setModuleInfo() {
            this.setTemplateModuleInfo({
                templateModel: 'competence-templates',
                model: 'competences',
                type: 'competence',
                children: 'competences',
                autocomplete: true,
                hasPivot: true,
                pivot_id: 'competence_id',
                allowDuplicate: false,
                title: {
                    attribute: 'title',
                    locale: this.locale
                },
                text: {
                    title: this.$t('settings.competence-templates.title'),
                    sub_title: this.$t('competence-templates.your_competences'),
                    new_item: this.$t('competence-templates.new_competence'),
                    item_short: 'C',
                    no_items_found: this.$t('settings.competence-templates.no_competences')
                },
            });

            // Only load 'ModuleTemplates' - component when the module info is set
            this.moduleInfoIsSet = true
        },
        async fetchJobs() {
            this.fetchingJobs = true;
            return jobService.names('competence_template').then(result => {
                this.allJobs = Object.values(result);
            }).then(() => {
                this.selectedJobs = this.getSelectedJobs();
                this.updateJobAttributes();
                this.fetchingJobs = false;
            });
        },
        toggleLinkedJob(event) {
            this.saving = true;
            competenceTemplateService.linkJobs(this.template.id,
                {data: event}
            ).then(() => {
                this[ADD_NOTIFICATION]({
                    type: 'success',
                    message: this.$t('competence-templates.jobs_linked'),
                });

                this.saving = false;
            });
        },
        setTooltip(job) {
            return job.competence_template.id ? this.$t('competence-templates.job_already_linked_to', {
                template: job.competence_template.title
            }) : null;
        },
        async selectionChanged(template) {
            this.template = template;
            await this.fetchJobs();
        },
        getSelectedJobs() {
            let selectedJobIds = this.template?.jobs && this.template.jobs.map(job => job.id);

            return this.allJobs.filter(job => selectedJobIds && selectedJobIds.indexOf(job.id) > -1);
        },
        updateJobAttributes() {
            this.allJobs.map(job => {
                job.disabled = job.competence_template.id > 0 && (job.competence_template.id !== this.template.id);
                job.tooltip = this.setTooltip(job);

                return job;
            });
        }
    },
    mounted() {
        this.setModuleInfo();
    },
}
</script>

<style scoped>

</style>
